import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "tooltip" }
const _hoisted_2 = ["id"]

import { withDefaults, onMounted } from "vue";

interface Props {
  direction: "top" | "right" | "bottom" | "text";
  tooltipId?: string;
  ballonLeft?: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'tool-tip',
  props: {
    direction: { default: "bottom" },
    tooltipId: {},
    ballonLeft: {}
  },
  setup(__props: any) {

const props = __props;



onMounted(() => {
  if (props.tooltipId) {
    const image = document.getElementById("tooltipImage-" + props.tooltipId);
    const tooltip = document.getElementById("tooltipSpan-" + props.tooltipId);
    image.addEventListener("mouseover", () => {
      const rect = tooltip.getBoundingClientRect();
      if (rect.right > window.innerWidth) {
        tooltip.style.left = window.innerWidth - rect.right + 22 + "px";
      }
    });
    image.addEventListener("mouseleave", () => {
      tooltip.style.left = "22px";
    });
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", _hoisted_1, [
    _renderSlot(_ctx.$slots, "label"),
    _createElementVNode("span", {
      class: _normalizeClass({
        'balloon-top': _ctx.direction === 'top',
        'balloon-right': _ctx.direction === 'right',
        'balloon-bottom': _ctx.direction === 'bottom',
        'text-tooltip': _ctx.direction === 'text',
      }),
      id: 'tooltipSpan-' + _ctx.tooltipId,
      style: _normalizeStyle({ left: _ctx.ballonLeft })
    }, [
      _renderSlot(_ctx.$slots, "content")
    ], 14, _hoisted_2)
  ]))
}
}

})